'use client';

import {
  Benefits,
  Companies,
  Header,
  PowerBlock,
  Switcher,
  Welcome,
} from 'src/components/ChristofariBlocks';
import { VideoPlayer } from 'src/components/VideoPlayer';
import { Wrapper } from 'src/components/Wrapper';
import { useIntersectionObserveForms } from 'src/hooks/useIntersectionObserverForms';
import { Layout } from 'src/layout';
import { Breadcrumbs } from 'src/uikit/Breadcrumbs';
import { Form } from 'src/uikit/Form';
import { scrollToElementWithId } from 'src/utils/scrollToElementWithId';

import s from '../christofari/Christofari.module.scss';
import { ChristofariNeoData } from './mockChristofariNeo';

export function ChristofariNeoPage({ data }: { data: ChristofariNeoData }) {
  const { formRef, setAnchorId } = useIntersectionObserveForms({
    formName: 'lead-products',
  });

  const handleButtonClickToForm = (anchorId: string) => {
    scrollToElementWithId('form');
    setAnchorId(anchorId);
  };

  const breadcrumbsLinks = [
    {
      title: 'Главная',
      link: '/',
    },
    {
      title: 'Платформа Cloud․ru ML Space',
      link: '/mlspace',
    },
    {
      title: data.header.title,
    },
  ];

  return (
    <Layout>
      <div className={s.root}>
        <div className={s.chrisWrapper}>
          <Wrapper className={s.breadcrumbsWrapper}>
            <Breadcrumbs
              className={s.breadcrumbs}
              links={breadcrumbsLinks}
              color={Breadcrumbs.colors.White}
            />
          </Wrapper>
          <Switcher version="christofari-neo" />
          <Header
            onClick={handleButtonClickToForm}
            title={data.header.title}
            subtitle={data.header.subtitle}
            text={data.header.text}
            buttonText={data.header.buttonText}
            gtmButtonStyle="gtm-btn-to-form_christofari-neo"
            videoTitle={data.header.videoTitle}
            videoLink={data.header.videoLink}
            variant="christofari-neo"
          />
          <PowerBlock title={data.petaflops.title} rate={data.petaflops.rate} />
          <VideoPlayer
            className={s.chrisVideofirst}
            videoClassName={s.chrisVideofirstVideo}
            previewImage="https://cdn.cloud.ru/backend/images/christofari/kris1.jpg"
            link="https://cdn-video.cloud.ru/backend/video/christofari/chris1.mp4"
            customError
            muted
          />
          <Benefits
            title={data.benefits.title}
            footerText={data.benefits.footerText}
            items={data.benefits.items}
          />
          <Companies />
          <VideoPlayer
            className={s.chrisVideothird}
            videoClassName={s.chrisVideothirdVideo}
            previewImage="https://cdn.cloud.ru/backend/images/christofari/kris4.jpg"
            link="https://cdn-video.cloud.ru/backend/video/christofari/chris4.mp4"
            customError
            muted
          />
          <Welcome title={data.welcome.title} />

          <Form
            id="form"
            legalEntity
            ref={formRef}
            inputPath="v2/order"
            productSlug="christofari-neo"
            title="Оставьте заявку на консультацию"
            allFormsSentFormType="sale"
            analyticsFieldFill={{ formType: 'body' }}
            formVariant="inner"
            successfulSubmissonFormAnalytics={{
              formname: 'lead-products',
            }}
          />
        </div>
      </div>
    </Layout>
  );
}
